module.exports = __webpack_public_path__ + "static/media/Reproductor_Expand.312fbdf5.png";